import { render, staticRenderFns } from "./IssuesGrid.vue?vue&type=template&id=0d49a93d"
import script from "./IssuesGrid.vue?vue&type=script&lang=js"
export * from "./IssuesGrid.vue?vue&type=script&lang=js"
import style0 from "./IssuesGrid.vue?vue&type=style&index=0&id=0d49a93d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports